export default __webpack_public_path__ + "static/media/featBg.d468b693.jpg";